import { c as _c } from "react/compiler-runtime";
// Tremor Raw Badge [v0.0.0]
import * as AccordionPrimitives from "@radix-ui/react-accordion";
import React from "react";
import { FaChevronDown } from "react-icons/fa";
import { cx } from "@/lib/tailwind-utils";
const Accordion = AccordionPrimitives.Root;
Accordion.displayName = "AccordionItem";
const AccordionTrigger = React.forwardRef<React.ElementRef<typeof AccordionPrimitives.Trigger>, React.ComponentPropsWithoutRef<typeof AccordionPrimitives.Trigger> & {
  icon?: React.ElementType<{
    className?: string;
  }>;
  iconClassName?: string;
  iconPosition?: "start" | "end";
}>((t0, forwardedRef) => {
  const $ = _c(24);
  let children;
  let className;
  let iconClassName;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      children,
      icon: t1,
      iconClassName,
      iconPosition: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = iconClassName;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    iconClassName = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const Icon = t1 === undefined ? FaChevronDown : t1;
  const iconPosition = t2 === undefined ? "end" : t2;
  let t3;
  if ($[7] !== className) {
    t3 = cx("group flex flex-1 cursor-pointer items-center justify-between py-3 text-left text-body-strong leading-none", "text-foreground", "data-[disabled]:cursor-not-allowed data-[disabled]:text-foreground-muted", "transition-all duration-300", "data-[state=closed]:rounded-b-xl", "focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary", className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== Icon || $[10] !== iconClassName || $[11] !== iconPosition) {
    t4 = iconPosition === "start" && <Icon className={cx("size-5 shrink-0 transition-transform duration-150 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-data-[state=open]:-rotate-180 text-foreground-muted group-data-[disabled]:text-muted-foreground", iconClassName)} aria-hidden="true" focusable="false" />;
    $[9] = Icon;
    $[10] = iconClassName;
    $[11] = iconPosition;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== Icon || $[14] !== iconClassName || $[15] !== iconPosition) {
    t5 = iconPosition === "end" && <Icon className={cx("size-5 shrink-0 transition-transform duration-150 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-data-[state=open]:-rotate-180 text-foreground-muted group-data-[disabled]:text-muted-foreground", iconClassName)} aria-hidden="true" focusable="false" />;
    $[13] = Icon;
    $[14] = iconClassName;
    $[15] = iconPosition;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== children || $[18] !== forwardedRef || $[19] !== props || $[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <AccordionPrimitives.Header className="flex"><AccordionPrimitives.Trigger className={t3} {...props} ref={forwardedRef}>{t4}{children}{t5}</AccordionPrimitives.Trigger></AccordionPrimitives.Header>;
    $[17] = children;
    $[18] = forwardedRef;
    $[19] = props;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
});
AccordionTrigger.displayName = "AccordionTrigger";
const AccordionContent = React.forwardRef<React.ElementRef<typeof AccordionPrimitives.Content>, React.ComponentPropsWithoutRef<typeof AccordionPrimitives.Content>>((t0, forwardedRef) => {
  const $ = _c(14);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cx("data-[state=closed]:animate-accordionClose data-[state=open]:animate-accordionOpen data-[state=closed]:overflow-hidden");
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== className) {
    t2 = cx("overflow-visible pb-4 text-body", "text-foreground-secondary", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[7] = children;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== forwardedRef || $[11] !== props || $[12] !== t3) {
    t4 = <AccordionPrimitives.Content ref={forwardedRef} className={t1} {...props}>{t3}</AccordionPrimitives.Content>;
    $[10] = forwardedRef;
    $[11] = props;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
});
AccordionContent.displayName = "AccordionContent";
const AccordionItem = React.forwardRef<React.ElementRef<typeof AccordionPrimitives.Item>, React.ComponentPropsWithoutRef<typeof AccordionPrimitives.Item>>((t0, forwardedRef) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cx("overflow-visible border-b first:mt-0", "border-border", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== forwardedRef || $[6] !== props || $[7] !== t1) {
    t2 = <AccordionPrimitives.Item ref={forwardedRef} className={t1} {...props} />;
    $[5] = forwardedRef;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
AccordionItem.displayName = "AccordionItem";
export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };